import React, { useEffect, useState, useRef } from 'react';
export function FadeIn({
  children,
  delay = 0,
  className = '',
  direction = 'up'
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  direction?: 'up' | 'left' | 'right' | 'none';
}) {
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.unobserve(el);
      }
    }, {
      rootMargin: '-50px'
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  const translateY = direction === 'up' ? '20px' : '0px';
  const translateX = direction === 'left' ? '20px' : direction === 'right' ? '-20px' : '0px';
  return <div ref={ref} className={className} style={{
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? 'translate(0, 0)' : `translate(${translateX}, ${translateY})`,
    transition: `opacity 0.5s ease ${delay}s, transform 0.5s ease ${delay}s`,
    willChange: isVisible ? 'auto' : 'opacity, transform'
  }} data-id="element-57">
      {children}
    </div>;
}